import React from "react"
import { connectStats } from "react-instantsearch-dom"

export const CustomStats = connectStats(({ processingTimeMS, nbHits }) => (
  <p className="has-text-white title is-7 my-auto pr-3">
    {nbHits.toLocaleString()} Ergebnisse in {processingTimeMS.toLocaleString()}
    ms gefunden
  </p>
))
